// extracted by mini-css-extract-plugin
export default {"main_page":"ToyotaPrado_main_page__Uugbp","car_image":"ToyotaPrado_car_image__mvP6C"};